import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './pages/home.component';
import { AboutComponent } from './pages/about.component';
import { ConceptComponent } from './pages/concept.component';
import { NewsComponent } from './pages/news.component';
import { ArticleComponent } from './pages/article.component';
import { FeedComponent } from './pages/feed.component';
import { AccountComponent } from './pages/account.component';
import { RoutesComponent } from './pages/routes.component';
import { InteractiveMapComponent } from './pages/interactive-map.component';
import { ResponsibilityComponent } from './pages/responsibility.component';
import { ParticipantsComponent } from './pages/participants.component';
// import { FAQComponent } from './pages/faq.component';
import { ScheduleComponent } from './pages/schedule.component';
import { VacancyComponent } from './pages/vacancy.component';
import { RuleComponent } from './pages/rule.component';
import { PolicyComponent } from './pages/policy.component';
import { PaymentInfoComponent } from './pages/payment-info.component';
import { PayComponent } from './pages/pay.component';
import { TicketComponent } from './pages/ticket.component';
import { RecoverPasswordComponent } from './pages/recover-password.component';
import { AgreementComponent } from './pages/agreement.component';
import { PaymentPolicyComponent } from './pages/payment-policy.component';

const routes: Routes = [
    {
        path: '',
        component: HomeComponent
    },
    {
        path: 'about',
        component: AboutComponent
    },
    {
        path: 'concept',
        component: ConceptComponent
    },
    {
        path: 'news',
        component: NewsComponent
    },
    {
        path: 'news/article',
        component: ArticleComponent
    },
    {
        path: 'feed',
        component: FeedComponent
    },
    {
        path: 'account',
        component: AccountComponent
    },
    {
        path: 'routes',
        component: RoutesComponent
    },
    {
        path: 'pay',
        component: PayComponent
    },
    {
        path: 'interactive-map',
        component: InteractiveMapComponent
    },
    {
        path: 'responsibility',
        component: ResponsibilityComponent
    },
    {
        path: 'participants',
        component: ParticipantsComponent
    },
    // {
    //     path: 'faq',
    //     component: FAQComponent
    // },
    {
        path: 'schedule',
        component: ScheduleComponent
    },
    {
        path: 'schedule/:routeNumber',
        component: ScheduleComponent
    },
    {
        path: 'schedule/:routeNumber/:stopId',
        component: ScheduleComponent
    },
    {
        path: 'vacancy',
        component: VacancyComponent
    },
    {
        path: 'rules',
        component: RuleComponent
    },
    {
        path: 'policy',
        component: PolicyComponent
    },
    {
        path: 'payment-info',
        component: PaymentInfoComponent
    },
    {
        path: 'ticket/:id',
        component: TicketComponent
    },
    {
        path: 'resetPassword',
        component: RecoverPasswordComponent
    },
    {
        path: 'agreement',
        component: AgreementComponent
    },
    {
        path: 'paymentPolicy',
        component: PaymentPolicyComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/app-routing.module.ts